import { BehaviorSubject } from 'rxjs';

export const queriesInProgress$ = new BehaviorSubject(0);
